import React from "react";
import Rcslider from "rc-slider";
import cx from "classnames";
import "rc-slider/assets/index.css";
import "./slider.scss";

const Slider = ({
  className,
  label,
  marks,
  errors,
  onChange,
  name,
  value,
  // hint,
  min = 0,
  max,
  disabled = false,
  railStyle = { backgroundColor: "#c5c5c5" },
  trackStyle = { backgroundColor: "var(--accent)" },
  step = null,
}) => {
  return (
    <div className={cx(className, "slider")}>
      {label && (
        <label className={cx("labelSlider", { labelWithErrors: errors })}>{label || name.replace("_", " ")}</label>
      )}
      {/* TODO: fix hint */}
      {/* {hint && <div className="hint">{hint}</div>} */}
      <Rcslider
        value={value}
        disabled={disabled}
        onChange={(value) => onChange({ [name]: value })}
        railStyle={railStyle}
        trackStyle={trackStyle}
        marks={marks}
        step={step}
        min={min}
        max={max}
        defaultValue={0}
      />
    </div>
  );
};

export default Slider;
